<template>
  <section v-on:click="sectionClicked" class="">
    <div class="cnt">
      <div class="sectionHeader" v-if="section.title[lang] || section.descriptions[lang]">
        <h4 class="sectionTitle" v-if="section.title[lang]">{{section.title[lang]}}</h4>
        <p class="sectionDesc" v-if="section.descriptions[lang]">{{section.descriptions[lang]}}</p>
      </div>
    </div>
    <div :class="{cnt: !section.config.fullScreen}" class="customBlockWrapper"
      v-if="section.config">
      <div class="customBlockCnt" v-html="section.config.code[lang]"
        v-if="section.config.code"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'customBlock',
  props: ['section'],
  components: {},
  data() {
    return {
      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
.customBlockCnt{
  text-align: center;
}
.mapboxWrapper.cnt .mapboxCnt{
  // border-radius: 10px;
  // overflow: hidden;
}
</style>
